import { attr } from 'redux-orm';
import Model from '../base-model';
import choiceReducers from './choice.reducer';
import { choiceActions } from './choice.action';

/**
 * Choice
 * @typedef {Object} Choice
 * @property {string} id
 * @property {string} text
 * @property {boolean} isCorrect
 * @property {boolean} isCheck
 */

export class Choice extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case choiceActions.selectChoice:
            choiceReducers.selectChoice(session, action.id);
            break;
        case choiceActions.deSelectChoice:
            choiceReducers.deSelectChoice(session, action.id);
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Choice: ${this.text}`
    }
}

Choice.modelName = 'Choice';

Choice.fields = {
    id: attr(),
    text: attr(),
    isCorrect: attr(),
    isCheck: attr(),
}